module.exports = __webpack_public_path__ + "img/img3.82930bf4.png";